<span *ngIf="visible" class="row-state-badge"></span>
